import { render, staticRenderFns } from "./orgInfo.vue?vue&type=template&id=906a9a8c&scoped=true&"
import script from "./orgInfo.js?vue&type=script&lang=js&"
export * from "./orgInfo.js?vue&type=script&lang=js&"
import style0 from "./orgInfo.vue?vue&type=style&index=0&id=906a9a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906a9a8c",
  null
  
)

export default component.exports